export default __webpack_public_path__ + "static/search-a290eda457c9aaefb9ca96baf19d05fd.gif";